/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import { enableProdMode } from '@angular/core';

import { environment } from 'environments/environment';

import { loadTranslations } from '@angular/localize';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { getParamFromUrl } from '@orgbrain/lib-data';
import { getLangFromNavigator, useSupportedLocale } from '@orgbrain/lib-angular-util';
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

// mainly to force 'en' for testing
let lang = environment.defaultLang;
if (!lang) {
  lang = getParamFromUrl({ paramName: 'uselocale', url: window.location.href });
  if (lang) {
    localStorage.setItem('orgbrainLang', useSupportedLocale(lang));
  }
}
if (!lang) {
  lang = localStorage.getItem('orgbrainLang');

  if (!lang) {
    lang = getLangFromNavigator();
    localStorage.setItem('orgbrainLang', lang);
  }
}

lang = ['en', 'nb'].includes(lang) ? lang : 'nb';

fetch(`./assets/i18n/messages.${lang}.json`)
  .then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    return response.json();
  })
  .then((result) => {
    loadTranslations(result.translations);

    import('./app/app.module').then((module) => {
      platformBrowserDynamic()
        .bootstrapModule(module.AppModule)
        .catch((err) => console.error('Error in loading translations', err));
    });
  });

posthog.init('phc_pTotOw4SlVLBMM1lFe6qMev1uHu1eMQCgkeUbCuEpYB', {
  api_host: 'https://eu.i.posthog.com',
  capture_pageview: false,
  autocapture: false,
  disable_session_recording: true,
  opt_out_capturing_by_default: true,
});
